import { action } from 'satcheljs';
import { SearchRequestInstrumentation } from 'owa-search-service';

export const addSearchRequestInstrumentation = action(
    '__DIAGNOSTICS_SEARCH_ADD_SEARCH_REQUEST_INSTRUMENTATION',
    (searchRequestInstrumentation: SearchRequestInstrumentation) => ({
        searchRequestInstrumentation,
    })
);
